/* eslint-disable jsx-a11y/no-static-element-interactions */
import * as React from 'react'
import styled from 'styled-components'
import {
  commonProps,
  CommonProps,
  touchableProps,
  TouchableProps as CssTouchableProps,
  compose,
  sx,
  SxProps
} from '@bestyled/system'
import { Text } from './Text'
import { View } from './View'

type event = (e: any) => void

export interface TouchableProps
  extends CommonProps,
    CssTouchableProps,
    SxProps {
  onPress?: event
  onMouseDown?: event
  onMouseEnter?: event
  onMouseLeave?: event
  onMouseMove?: event
  onMouseOver?: event
  onMouseOut?: event
  onMouseUp?: event
  onKeyPress?: event
  style?: any
  className?: string
  title?: string
}

function wrapSingleView(item, childProps) {
  return React.cloneElement(item, childProps)
}

function wrapSingleText(item, childProps) {
  if (typeof item === 'string' || item == null) {
    return React.createElement(Text, childProps, item)
  }
  return wrapSingleView(item, childProps)
}

function ChildOnly(children, childProps) {
  return React.Children.count(children) > 1
    ? React.createElement(View, childProps, React.Children.toArray(children))
    : wrapSingleText(children, childProps)
}

export const TouchableBase: React.FC<TouchableProps> = React.forwardRef(
  (props, ref) => {
    // const [hover, setHover] = React.useState(false)

    const didPress = React.useCallback(
      (e: any) => {
        e.preventDefault()
        if (props.onPress) {
          props.onPress(e)
        }
      },
      [props.onPress]
    )

    const didMouseEnter = React.useCallback(
      (e: any) => {
        // setHover(true)
        if (props.onMouseEnter) {
          props.onMouseEnter(e)
        }
      },
      [props.onMouseEnter]
    )

    const didMouseLeave = React.useCallback(
      (e: any) => {
        // setHover(false)
        if (props.onMouseLeave) {
          props.onMouseLeave(e)
        }
      },
      [props.onMouseLeave]
    )

    const didKeyPress = React.useCallback(
      (e: any) => {
        if (props.onKeyPress) {
          props.onKeyPress(e)
        }
      },
      [props.onKeyPress]
    )

    const {
      children,
      onMouseEnter,
      onMouseLeave,
      style,
      className,
      title,
      ...rest
    } = props

    const child = ChildOnly(children, { style, ref })

    return (
      <div
        onClick={didPress}
        onMouseEnter={didMouseEnter}
        onMouseLeave={didMouseLeave}
        onKeyPress={didKeyPress}
        className={className}
        title={title}
        itemType="Touchable"
        /*  {...rest} */
      >
        {child}
      </div>
    )
  }
)

export const Touchable = styled(TouchableBase)`
  display: inline-flex;
  align-items: inherit;
  box-sizing: inherit;
  flex-basis: inherit;
  flex-direction: inherit;
  flex-shrink: inherit;
  align-content: inherit;
  justify-content: inherit;
  align-items: inherit;
  align-self: stretch;
  z-index: inherit;
  position: relative;
  margin: 0;
  padding: 0;
  min-height: 0;
  min-width: 0;
  ${compose(commonProps, touchableProps)} ${sx}
` as React.FC<TouchableProps>

Touchable.defaultProps = {
  cursor: 'pointer'
}
